<script setup lang="ts">
import ReferencesDetailContent from './ReferencesDetailContent.vue'
import ReferencesDetailHeader from './ReferencesDetailHeader.vue'
import { useReferencesDetail } from '~/composables/api/useReferencesDetail'

const { t } = useI18n()
const route = useRoute()
const referenceId = route.params.id as string

const referencesDetailResponse = await useAsyncData(
  `references-detail-${referenceId}`,
  () => {
    return useReferencesDetail(referenceId)
  }
)

if (!referencesDetailResponse.data?.value) {
  throw createError({
    statusCode: 404,
    statusMessage: t('pages.references.notFound'),
  })
}

// redirect, if url slug is not matching the slug in fetched data
if (
  referencesDetailResponse.data?.value &&
  referencesDetailResponse.data?.value?.slug !== route.params.slug
) {
  await navigateTo({
    path: useLocaleLink({
      name: 'references-slug-id',
      params: {
        slug: referencesDetailResponse.data.value.slug,
        id: referencesDetailResponse.data.value.id,
      },
    })?.fullPath,
  })
}

useHead({
  title: referencesDetailResponse.data.value.name,
  meta: [
    {
      name: 'description',
      content: t('pages.referencesDetail.description', {
        _0: referencesDetailResponse.data.value.name,
      }),
    },
  ],
})

defineOgImage({
  component: 'root',
  url: `https://images-cbre-cdn.rshop.sk/default/${referencesDetailResponse.data.value.image as string}`,
  width: 1200,
  height: 630,
})
</script>

<template>
  <div v-if="referencesDetailResponse.data.value" class="c-references-detail">
    <ReferencesDetailHeader
      class="c-references-detail__header"
      :reference-detail="referencesDetailResponse.data.value"
    />

    <ReferencesDetailContent
      :reference-detail="referencesDetailResponse.data.value"
    />
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-references-detail {
  &__header {
    margin-bottom: 64px;
  }
}
</style>
